const enums = {
  GENERAL: { text: '一般', value: 1 },
  COLOR: { text: '颜色', value: 2 },
  IMAGE: { text: '图片', value: 3 }
}
export default enums
